<template>
  <div class="text-white x-footer">
    <div class="container-fluid">
      <div class="row mb-4 row_wrap">
        <div class="col-lg-4">
          <img
            src="/images/coinx-logo.png"
            alt="coinx-logo"
            style="height: 42px; margin-bottom: 24px; margin-right: 7px"
          />

          <div class="footer_sosmed">
            <!-- link telegram -->
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clip-path="url(#clip0_19_6084)">
                  <path
                    d="M21.5 0H10.5C4.70101 0 0 4.70101 0 10.5V21.5C0 27.299 4.70101 32 10.5 32H21.5C27.299 32 32 27.299 32 21.5V10.5C32 4.70101 27.299 0 21.5 0Z"
                    fill="white"
                    fill-opacity="0.12"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint0_linear_19_6084)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint1_linear_19_6084)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M22.6361 9.64105C22.6361 9.64105 24.1161 9.06405 23.9931 10.4661C23.9521 11.0431 23.5821 13.0631 23.2931 15.2481L22.3071 21.7201C22.3071 21.7201 22.2251 22.6681 21.4851 22.8331C20.7451 22.9981 19.6351 22.2561 19.4291 22.0911C19.2651 21.9671 16.3451 20.1121 15.3181 19.2051C15.0301 18.9581 14.7011 18.4631 15.3581 17.8861L19.6761 13.7641C20.1691 13.2691 20.6621 12.1141 18.6061 13.5161L12.8511 17.4331C12.8511 17.4331 12.1931 17.8451 10.9591 17.4731L8.28711 16.6491C8.28711 16.6491 7.30011 16.0311 8.98611 15.4131C13.0971 13.4751 18.1541 11.4961 22.6361 9.64105Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_19_6084"
                    x1="32"
                    y1="36.952"
                    x2="16"
                    y2="16.762"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0.12" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_19_6084"
                    x1="14.857"
                    y1="16.762"
                    x2="1.14299"
                    y2="-3.81001"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" stop-opacity="0.34" />
                  </linearGradient>
                  <clipPath id="clip0_19_6084">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>

            <!-- link instagram -->
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clip-path="url(#clip0_19_6090)">
                  <path
                    d="M21.5 0H10.5C4.70101 0 0 4.70101 0 10.5V21.5C0 27.299 4.70101 32 10.5 32H21.5C27.299 32 32 27.299 32 21.5V10.5C32 4.70101 27.299 0 21.5 0Z"
                    fill="white"
                    fill-opacity="0.12"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint0_linear_19_6090)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint1_linear_19_6090)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M16.0052 8.78495C18.3582 8.78495 18.6362 8.79495 19.5622 8.83695C20.4222 8.87395 20.8862 9.01895 21.1952 9.13895C21.6052 9.29695 21.9002 9.48895 22.2072 9.79595C22.5172 10.106 22.7052 10.398 22.8632 10.806C22.9832 11.116 23.1282 11.584 23.1662 12.44C23.2072 13.368 23.2182 13.647 23.2182 15.995C23.2182 18.346 23.2082 18.625 23.1662 19.55C23.1282 20.41 22.9842 20.874 22.8632 21.183C22.7052 21.593 22.5132 21.888 22.2072 22.193C21.8972 22.503 21.6052 22.693 21.1952 22.85C20.8852 22.97 20.4182 23.115 19.5622 23.153C18.6322 23.194 18.3542 23.205 16.0052 23.205C13.6532 23.205 13.3742 23.195 12.4492 23.153C11.5892 23.115 11.1242 22.971 10.8152 22.851C10.4333 22.7103 10.0879 22.4857 9.8042 22.194C9.51197 21.9106 9.28741 21.5651 9.1472 21.183C9.0272 20.873 8.8822 20.406 8.8442 19.55C8.8032 18.622 8.7922 18.343 8.7922 15.995C8.7922 13.643 8.8022 13.365 8.8442 12.44C8.8822 11.58 9.0262 11.116 9.1472 10.807C9.3052 10.397 9.4972 10.102 9.8042 9.79595C10.1142 9.48595 10.4062 9.29695 10.8142 9.13895C11.1242 9.01895 11.5922 8.87395 12.4492 8.83695C13.3742 8.79495 13.6532 8.78495 16.0052 8.78495ZM16.0052 7.19995C13.6152 7.19995 13.3152 7.20995 12.3762 7.25195C11.4412 7.29195 10.7982 7.44395 10.2412 7.66095C9.65241 7.88161 9.1192 8.22878 8.6792 8.67795C8.1872 9.16695 7.8882 9.65795 7.6612 10.236C7.4442 10.796 7.2932 11.436 7.2512 12.371C7.2112 13.313 7.2002 13.612 7.2002 16.001C7.2002 18.391 7.2102 18.691 7.2522 19.629C7.2922 20.564 7.4442 21.207 7.6612 21.764C7.88219 22.3525 8.2297 22.8854 8.6792 23.325C9.1672 23.813 9.6592 24.115 10.2372 24.339C10.7972 24.556 11.4372 24.707 12.3732 24.749C13.3122 24.789 13.6112 24.7999 16.0022 24.7999C18.3922 24.7999 18.6922 24.79 19.6302 24.748C20.5662 24.708 21.2102 24.556 21.7662 24.339C22.3532 24.1185 22.8849 23.7724 23.3242 23.325C23.8132 22.837 24.1152 22.345 24.3392 21.767C24.5562 21.207 24.7072 20.567 24.7492 19.632C24.7892 18.694 24.8002 18.395 24.8002 16.005C24.8002 13.615 24.7902 13.317 24.7482 12.378C24.7082 11.443 24.5562 10.8 24.3392 10.243C24.1269 9.65126 23.7821 9.11595 23.3312 8.67795C22.8919 8.23052 22.3602 7.88446 21.7732 7.66395C21.2132 7.44795 20.5732 7.29595 19.6372 7.25495C18.6952 7.20995 18.3962 7.19995 16.0052 7.19995Z"
                    fill="white"
                  />
                  <path
                    d="M16.0049 11.48C14.8055 11.48 13.6552 11.9564 12.807 12.8044C11.9588 13.6524 11.4822 14.8026 11.4819 16.002C11.4819 17.2015 11.9585 18.352 12.8067 19.2002C13.6549 20.0484 14.8054 20.525 16.0049 20.525C17.2045 20.525 18.3549 20.0484 19.2032 19.2002C20.0514 18.352 20.5279 17.2015 20.5279 16.002C20.5274 14.8027 20.0506 13.6528 19.2025 12.805C18.3543 11.9572 17.2042 11.481 16.0049 11.481V11.48ZM16.0049 18.934C15.6151 18.9412 15.2278 18.8706 14.8656 18.7264C14.5034 18.5822 14.1736 18.3673 13.8954 18.0942C13.6172 17.8211 13.3962 17.4953 13.2453 17.1358C13.0945 16.7763 13.0168 16.3903 13.0168 16.0005C13.0168 15.6106 13.0945 15.2247 13.2453 14.8652C13.3962 14.5057 13.6172 14.1799 13.8954 13.9068C14.1736 13.6336 14.5034 13.4187 14.8656 13.2745C15.2278 13.1303 15.6151 13.0598 16.0049 13.067C16.7736 13.0812 17.5059 13.3965 18.0445 13.9451C18.583 14.4937 18.8848 15.2317 18.8848 16.0005C18.8848 16.7692 18.583 17.5073 18.0445 18.0559C17.5059 18.6045 16.7736 18.9198 16.0049 18.934ZM21.7619 11.302C21.7662 11.4433 21.7421 11.5841 21.6909 11.7159C21.6398 11.8478 21.5627 11.968 21.4642 12.0694C21.3657 12.1709 21.2478 12.2516 21.1176 12.3066C20.9873 12.3617 20.8473 12.39 20.7059 12.39C20.5645 12.3899 20.4246 12.3614 20.2943 12.3062C20.1641 12.2511 20.0464 12.1703 19.948 12.0687C19.8496 11.9672 19.7726 11.8469 19.7216 11.715C19.6705 11.5831 19.6465 11.4423 19.6509 11.301C19.6594 11.0267 19.7743 10.7664 19.9713 10.5754C20.1683 10.3843 20.432 10.2775 20.7064 10.2775C20.9809 10.2775 21.2445 10.3843 21.4416 10.5754C21.6386 10.7664 21.7535 11.0267 21.7619 11.301V11.302Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_19_6090"
                    x1="32"
                    y1="36.952"
                    x2="16"
                    y2="16.762"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0.12" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_19_6090"
                    x1="14.857"
                    y1="16.762"
                    x2="1.14299"
                    y2="-3.81001"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" stop-opacity="0.34" />
                  </linearGradient>
                  <clipPath id="clip0_19_6090">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>

            <!-- link youtube -->
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clip-path="url(#clip0_19_6097)">
                  <path
                    d="M21.5 0H10.5C4.70101 0 0 4.70101 0 10.5V21.5C0 27.299 4.70101 32 10.5 32H21.5C27.299 32 32 27.299 32 21.5V10.5C32 4.70101 27.299 0 21.5 0Z"
                    fill="white"
                    fill-opacity="0.12"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint0_linear_19_6097)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint1_linear_19_6097)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M24.82 12.732C24.82 12.732 24.645 11.491 24.104 10.946C23.418 10.229 22.652 10.225 22.3 10.183C19.783 10 16.003 10 16.003 10H15.996C15.996 10 12.217 10 9.7 10.183C9.348 10.225 8.582 10.229 7.896 10.946C7.356 11.491 7.183 12.732 7.183 12.732C7.183 12.732 7 14.19 7 15.646V17.01C7 18.466 7.18 19.925 7.18 19.925C7.18 19.925 7.355 21.165 7.893 21.71C8.579 22.428 9.479 22.403 9.879 22.48C11.321 22.618 16 22.66 16 22.66C16 22.66 19.783 22.653 22.3 22.473C22.652 22.431 23.418 22.428 24.103 21.711C24.645 21.166 24.821 19.925 24.821 19.925C24.821 19.925 25 18.469 25 17.01V15.646C25 14.191 24.82 12.732 24.82 12.732ZM14.14 18.666V13.607L19.002 16.145L14.14 18.666Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_19_6097"
                    x1="32"
                    y1="36.952"
                    x2="16"
                    y2="16.762"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0.12" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_19_6097"
                    x1="14.857"
                    y1="16.762"
                    x2="1.14299"
                    y2="-3.81001"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" stop-opacity="0.34" />
                  </linearGradient>
                  <clipPath id="clip0_19_6097">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>

            <!-- link linkedin -->
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clip-path="url(#clip0_19_6103)">
                  <path
                    d="M21.5 0H10.5C4.70101 0 0 4.70101 0 10.5V21.5C0 27.299 4.70101 32 10.5 32H21.5C27.299 32 32 27.299 32 21.5V10.5C32 4.70101 27.299 0 21.5 0Z"
                    fill="white"
                    fill-opacity="0.12"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint0_linear_19_6103)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint1_linear_19_6103)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.182 8C8.53 8 8 8.514 8 9.146V22.854C8 23.487 8.53 24 9.182 24H22.817C23.471 24 24 23.487 24 22.854V9.146C24 8.513 23.47 8 22.817 8H9.182ZM12.862 14.187V21.39H10.468V14.187H12.862ZM13.02 11.959C13.02 12.65 12.5 13.203 11.666 13.203H11.65C10.846 13.203 10.327 12.65 10.327 11.959C10.327 11.252 10.862 10.714 11.681 10.714C12.501 10.714 13.004 11.252 13.02 11.959ZM16.581 21.389H14.187C14.187 21.389 14.219 14.863 14.187 14.187H16.582V15.207C16.9 14.716 17.469 14.017 18.739 14.017C20.315 14.017 21.496 15.047 21.496 17.26V21.39H19.102V17.537C19.102 16.568 18.755 15.907 17.889 15.907C17.227 15.907 16.833 16.353 16.66 16.784C16.597 16.937 16.581 17.153 16.581 17.368V21.389Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_19_6103"
                    x1="32"
                    y1="36.952"
                    x2="16"
                    y2="16.762"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0.12" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_19_6103"
                    x1="14.857"
                    y1="16.762"
                    x2="1.14299"
                    y2="-3.81001"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" stop-opacity="0.34" />
                  </linearGradient>
                  <clipPath id="clip0_19_6103">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>

            <!-- link X -->
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clip-path="url(#clip0_19_6109)">
                  <path
                    d="M23.6 0H8.4C3.76081 0 0 3.76081 0 8.4V23.6C0 28.2392 3.76081 32 8.4 32H23.6C28.2392 32 32 28.2392 32 23.6V8.4C32 3.76081 28.2392 0 23.6 0Z"
                    fill="white"
                    fill-opacity="0.12"
                  />
                  <path
                    d="M23.6002 0.350342H8.40099C3.95487 0.350342 0.350586 3.95463 0.350586 8.40074V23.5999C0.350586 28.0461 3.95487 31.6503 8.40099 31.6503H23.6002C28.0463 31.6503 31.6506 28.0461 31.6506 23.5999V8.40074C31.6506 3.95463 28.0463 0.350342 23.6002 0.350342Z"
                    stroke="url(#paint0_linear_19_6109)"
                    stroke-opacity="0.4"
                    stroke-width="0.7"
                  />
                  <path
                    d="M23.6002 0.350342H8.40099C3.95487 0.350342 0.350586 3.95463 0.350586 8.40074V23.5999C0.350586 28.0461 3.95487 31.6503 8.40099 31.6503H23.6002C28.0463 31.6503 31.6506 28.0461 31.6506 23.5999V8.40074C31.6506 3.95463 28.0463 0.350342 23.6002 0.350342Z"
                    stroke="url(#paint1_linear_19_6109)"
                    stroke-opacity="0.4"
                    stroke-width="0.7"
                  />
                  <path
                    d="M8.0392 8.5L14.216 16.76L8 23.4752H9.3992L14.8416 17.5952L19.2392 23.4752H24L17.4752 14.752L23.2608 8.5008H21.8616L16.8496 13.916L12.8 8.5H8.0392ZM10.0968 9.5312H12.284L21.9424 22.4448H19.7552L10.096 9.5304L10.0968 9.5312Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_19_6109"
                    x1="32.0002"
                    y1="36.9527"
                    x2="16.0002"
                    y2="16.7615"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0.12" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_19_6109"
                    x1="14.857"
                    y1="16.7615"
                    x2="1.14339"
                    y2="-3.80966"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" stop-opacity="0.34" />
                  </linearGradient>
                  <clipPath id="clip0_19_6109">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>

            <!-- link tiktok -->
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clip-path="url(#clip0_19_6115)">
                  <path
                    d="M21.5 0H10.5C4.70101 0 0 4.70101 0 10.5V21.5C0 27.299 4.70101 32 10.5 32H21.5C27.299 32 32 27.299 32 21.5V10.5C32 4.70101 27.299 0 21.5 0Z"
                    fill="white"
                    fill-opacity="0.12"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint0_linear_19_6115)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M21.5 0.437988H10.501C4.94335 0.437988 0.437988 4.94335 0.437988 10.501V21.5C0.437988 27.0576 4.94335 31.563 10.501 31.563H21.5C27.0576 31.563 31.563 27.0576 31.563 21.5V10.501C31.563 4.94335 27.0576 0.437988 21.5 0.437988Z"
                    stroke="url(#paint1_linear_19_6115)"
                    stroke-opacity="0.4"
                    stroke-width="0.875"
                  />
                  <path
                    d="M19.058 8.19995H16.493V18.715C16.493 19.968 15.507 20.997 14.279 20.997C13.051 20.997 12.065 19.968 12.065 18.715C12.065 17.485 13.03 16.478 14.213 16.433V13.793C11.605 13.838 9.5 16.008 9.5 18.715C9.5 21.445 11.648 23.637 14.301 23.637C16.954 23.637 19.102 21.422 19.102 18.715V13.323C20.0857 14.0556 21.2737 14.4626 22.5 14.487V11.847C20.57 11.78 19.058 10.169 19.058 8.19995Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_19_6115"
                    x1="32"
                    y1="36.952"
                    x2="16"
                    y2="16.762"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0.12" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_19_6115"
                    x1="14.857"
                    y1="16.762"
                    x2="1.14299"
                    y2="-3.81001"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" stop-opacity="0.34" />
                  </linearGradient>
                  <clipPath id="clip0_19_6115">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
          <div class="footer_lisensed">
            <p>Terdaftar dan Dilisensikan oleh</p>
            <div class="lisensed_item">
              <img src="/images/km-perdagangan-logo.png" alt="mendagri" />
              <img src="/images/kominfo-logo.png" alt="tsi" />
              <img src="/images/cbqa-white-logo.png" alt="kominfo" />
            </div>
            <div class="lisensed_item">
              <div class="cfx">
                <p>Member of</p>
                <img src="/images/cfx-logo.png" alt="cfx" />
              </div>
              <img src="/images/kki-white-logo.png" alt="kki" />
            </div>
          </div>
        </div>

        <!-- <div class="side_right col-lg-3">
          <div class="link_w">
            <h5>Tentang</h5>
            <div>
              <ul class="x-pages">
                <li>
                  <router-link to="#" class="link_f link_g"
                    >Tentang kami</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/pages/term-and-conditions"
                    class="link_f link_g"
                  >
                    Hubungi kami
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

        </div> -->
      </div>

      <div class="row x-footer-bottom-section">
        <div class="col link_f">
          Peringatan<br />
          Perdagangan aset kripto memiliki risiko yang tinggi. Penting untuk
          menggunakan pertimbangan yang matang dalam mengambil keputusan untuk
          membeli atau menjual aset Kripto Anda. Coinx tidak memaksa pengguna
          untuk membeli dan menjual aset Kripto, dan semua keputusan untuk
          membeli atau menjual aset Kripto adalah pilihan independen yang dibuat
          oleh pengguna dalam jarak yang wajar dan tanpa paksaan. Produk yang
          diperdagangkan bukan milik Coinx; oleh karena itu, Coinx tidak
          bertanggung jawab atas nilai transaksi yang sedang berlangsung dan
          nilai akhir.
        </div>
      </div>

      <div class="footer_copy">
        <span>©2024 PT Kripto Inovasi Nusantara</span>
        <div class="copy_item">
          <router-link to="/pages/privacy-policy"
            >Kebijakan Privasi</router-link
          >
          <!-- <a href="#">Perjanjian Pengguna</a> -->
          <router-link to="/pages/term-and-conditions"
            >Peraturan Perdagangan</router-link
          >
          <!-- <router-link to="/pages/term-and-conditions"
            >Syarat & Ketentuan</router-link
          > -->
          <!-- <a href="#">Kebijakan Sistem Manajemen Keamanan Informasi</a> -->
          <router-link to="/pages/contact-us" class="link_f link_g">
            Hubungi Kami
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// node_modules

// applibs
import themain from "@/applibs/themain.js";

export default {
  components: {},
  data() {
    return {
      themain,
    };
  },

  async mounted() {},

  methods: {},
};
</script>

<style scoped>
.x-footer {
  padding-top: 46px;
  padding-bottom: 20px;
  /* margin-top: 60px; */
  width: 100%;
  background-color: #131926;
  /* height: 100%; */
  /* position: absolute;
  bottom: 0; */
}

ul.x-pages {
  list-style-type: none;
  padding-left: 0px;
  font-size: 0.9rem;
  line-height: 2rem;
  font-weight: 300;
}
ul.x-pages a {
  text-decoration: none;
}

.link_f {
  color: rgba(255, 255, 255, 0.54);
}

.nav-link:hover {
  color: #708cc7 !important;
}

.x-footer-bottom-section {
  border-top: 0.2px solid #b9b9b9;
  padding-top: 10px;
}

.x-footer-web-info {
  font-size: 0.8rem;
  color: #7c769c;
}
.link_w h5 {
  font-size: 16px;
  font-weight: normal;
}
.row_wrap {
  display: flex;
  justify-content: space-between;
}
.side_right {
  display: flex;
  justify-content: space-between;
}
.footer_sosmed {
  display: flex;
  gap: 10px;
  margin-bottom: 45px;
}
.footer_lisensed {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.lisensed_item {
  display: flex;
  gap: 20px;
}
.lisensed_item img {
  height: 44px;
  width: auto;
}
.footer_copy {
  display: flex;
  justify-content: space-evenly;
  margin: 54px 0 32px 0;
}
.copy_item {
  display: flex;
  gap: 20px;
}
.copy_item a,
.footer_copy span {
  color: rgba(232, 232, 234, 0.6);
  font-weight: lighter;
}

.lisensed_item {
  .cfx {
    display: flex;
    align-items: center;
    gap: 16px;
    p {
      font-size: 16px;
      margin-bottom: 0px;
      color: white;
    }
  }
}


@media only screen and (max-width: 960px) {
  .side_right {
    margin-top: 30px;
  }
}

@media only screen and (max-width: 500px) {
  .link_w {
    margin-top: 15px;
  }

  .link_w h5 {
    font-size: 16px;
  }

  .link_f {
    font-size: 14px;
  }
  .copy_item {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }
}
</style>
